/**
 * React Query client (BUILD_SPEC.md §3.2 — server-state via React Query).
 *
 * Configured for the dashboard's polling pattern: data is refetched on
 * a fixed cadence (set per-query), and we DO refetch on window focus
 * so the dashboard wakes up correctly after a screen lock. Errors don't
 * retry by default — most of our 4xxs are deterministic (validation,
 * auth) and silently retrying them just delays the user-visible error.
 */

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 30s of stale tolerance prevents noise refetches when the user
      // navigates between admin pages quickly. Per-query overrides
      // shorten this for the polling dashboard.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      // No retries — surface failures fast to the user. Network blips
      // are masked by React Query's automatic refetch on focus.
      retry: false,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: false,
    },
  },
});
